import { Spinner } from "@/components/ui/spinner";

export function RedirectSpinner() {
  return (
    <Spinner
      className={`
        text-slate-400
        system-dark:text-zinc-500
      `}
      size={18}
    />
  );
}
